export function LoadingScreen() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-6 bg-background">
      <img
        src={`${import.meta.env.BASE_URL}logo-full.svg`}
        alt="Gasworkers"
        className="w-30 h-30 fade-in"
      />
      <p className="animate-pulse text-muted-foreground text-sm">
        Загрузка...
      </p>
    </div>
  )
}
